import Vue from 'vue'
import bugsnag from '@/bugsnag'

function getInitialState () {
    return {
        authenticated: false,
        user: {},
        token: ''
    }
}

const state = getInitialState()

const mutations = {
    'AUTH_SET_TOKEN' (state, token) {
        state.token = token
        Vue.http.headers.common['Authorization'] = 'Bearer ' + token
    },
    'AUTH_LOGIN' (state, {user, token}) {
        state.user = user
        state.token = token
        state.authenticated = true
        Vue.http.headers.common['Authorization'] = 'Bearer ' + token
    },
    'AUTH_UPDATE' (state, user) {
        state.user = user
    },
    'AUTH_LOGOUT' (state) {
        state = Object.assign(state, getInitialState())
        delete Vue.http.headers.common['Authorization']
    }
}

const actions = {
    auth_login: function ({commit, dispatch}, {username, password}) {
        return new Promise((resolve, reject) => {
            Vue.http.post('users/authentication', null, { headers: {
                'Authorization': 'Basic ' + btoa(username + ':' + password)
            }}).then(response => {
                // Save the token for further use
                let token = response.body.Token

                // Fetch the user data
                Vue.http.get('user/me', { headers: {
                    'Authorization': 'Bearer ' + token
                }}).then(response => {
                    // Update the stored authentication information
                    commit('AUTH_LOGIN', {user: response.body.data.user, token: token})

                    // Set the user information for bugsnag
                    bugsnag.user = {
                        id: response.body.data.user.id,
                        name: response.body.data.user.username,
                        email: response.body.data.user.email
                    }

                    // Resolve the function
                    resolve()
                }).catch(error => {
                    bugsnag.notify(JSON.stringify(error))
                    reject(error)
                })
            }).catch(error => {
                bugsnag.notify(JSON.stringify(error))
                reject(error)
            })
        })
    },
    auth_register: function ({commit, dispatch}, {username, password, email}) {
        return new Promise((resolve, reject) => {
            Vue.http.post('users', {username, password, email}).then(response => {
                actions.auth_login({commit, dispatch}, {username, password}).then(() => {
                    resolve()
                }).catch(error => {
                    bugsnag.notify(JSON.stringify(error))
                    reject(error)
                })
            }).catch(error => {
                bugsnag.notify(JSON.stringify(error))
                reject(error)
            })
        })
    },
    auth_register_member: function ({commit, dispatch}, {username, password, email, organisation, permission}) {
        return new Promise((resolve, reject) => {
            Vue.http.post('users', {username, password, email, organisation: organisation.id, permission_level: permission}).then(response => {
                resolve()
            }).catch(error => {
                bugsnag.notify(JSON.stringify(error))
                reject(error)
            })
        })
    },
    auth_update: function ({commit}, {user, password = null, email = null, workarea = null}) {
        Vue.http.put('user/' + user.id, {password, email, workarea}).then(response => {
            commit('AUTH_UPDATE', response.body.data.user)
        }).catch(error => {
            bugsnag.notify(JSON.stringify(error))

            if (error.status === 401) {
                commit('AUTH_LOGOUT')
            }
        })
    },
    auth_logout: function ({commit}) {
        return new Promise((resolve, reject) => {
            commit('AUTH_LOGOUT')
            resolve()
        })
    }
}

const getters = {
    getAuthenticatedUser: function (state, getters) {
        return state.user
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/authentication.js